import React, { useEffect, useState } from "react";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import api from "@/lib/api";

export default function WhatsAppFloatButton() {
  const [settings, setSettings] = useState(() => {
    try { return JSON.parse(localStorage.getItem("gu_site_settings_v1")); } catch (e) { return null; }
  });

  useEffect(() => {
    api.get("/site-settings").then((res) => setSettings(res.data)).catch(() => {});
  }, []);

  if (!settings || settings.enable_whatsapp_widget === false) return null;

  const number = settings?.whatsapp_widget_number || process.env.REACT_APP_WHATSAPP_NUMBER || "917314344673";
  return (
    <a
      href={`https://wa.me/${number}?text=${encodeURIComponent("Hi Gulfudaan, I need help with my application.")}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      className="fixed bottom-20 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] shadow-xl flex items-center justify-center hover:scale-110 transition-transform animate-pulse-slow"
    >
      <WhatsAppIcon size={30} className="text-white" />
    </a>
  );
}
